const SETTINGS = {
  // baseAPIUrl: 'https://beta.api.fwcanvass.com/',
  // baseAPIUrl: 'https://crews.api.fwcanvass.com/',HEAD
  baseAPIUrl: 'https://api.fwcanvass.com/', // <---- THIS IS PROD
  // baseAPIUrl: 'http://127.0.0.1:8000/',
  googleMapsApiKey: 'AIzaSyAFa7DYfM9XVUMKSqbtSkUYsT2MU0ez8mY', // NEW FWCANVASS KEY - THIS IS GEOCODING KEY, MAY NEED ANOTHER FOR MAPS
  mapboxApiKey:
    'pk.eyJ1IjoiYWxleGdpbHNvbiIsImEiOiJjbG4wdDJ4eGMxcGcwMmlxdXNwa3A1ZXc5In0.dINhFz-zHChgqP0LCjgK9w', // NEW FWCANVASS KEY
  //image source settings
  thumbnailMediaRoot: 'https://fwcanvass-mobile-media-thumbnails.s3.us-east-2.amazonaws.com',
  largeFormatMediaRoot: 'https://fwcanvass-mobile-media-uploads.s3.us-east-2.amazonaws.com',
  // ADD open layers key here.
};

if (process.env.NODE_ENV === 'production') {
  SETTINGS.baseAPIUrl = 'https://api.fwcanvass.com/';
}

export default SETTINGS;
